module.exports = __webpack_public_path__ + "img/breviary1.49a7a845.jpg";